// website
import Header from "./Header";
import Banner from "./Banner";
import counter from "./Counter";
import brandpartners from "./BrandPartners";
import AboutSupplier from "./AboutSupplier";
import downloadapp from "./DownloadApp";
import faq from "./Faq";
import getquote from "./GetQuoteForm";
import ecosystem from "./PartOfMahal";
import restaurantdeals from "./RestaurantDeals";
import restaurantoffers from "./RestaurantOffers";
import supplierpartners from "./SupplierPartners";
import testimonial from "./Testimonial";
import restaurantabout from "./RestaurantAbout";
import footer from "./Footer";
//website Restaurent
import restaurantbanner from "./RestaurantBanner";
import restaurantabout2 from "./RestaurantAbout2";
import aboutapp from "./AboutApp";
import addbanner from "./AddBanner";
import startshopping from "./StartShopping";
import restaurantbenefits from "./RestaurantBenefits";
import Testimonial2 from "./Testimonial2";
import GetQuoteForm1 from "./GetQuoteForm1";
// website supplier
import supplierbanner from "./SupplierBanner";
import aboutservice from "./AboutService";
import AboutApp1 from "./AboutApp1";
import supplierpartner2 from "./supplierpartner2";
import startshoppingSupplier from "./StartShoppingSupplier";
import testimonialSupplier from "./TestimonialSupplier";
import supplierbenefits from "./supplierbenefits";
// About
import about from "./about";
import aboutServiceContent from "./aboutServiceContent";
import workProcessContent from "./workProcessContent";
import blogContent from "./blogContent";
import contactContent from "./contactContent";



export default {

  // Restaurent 
 
  // website
...Header,
...Banner,
...counter,
  ...brandpartners,

...AboutSupplier,
...downloadapp,
...faq,
...getquote,
...ecosystem,
...restaurantdeals,
...restaurantoffers,
...supplierpartners,
...testimonial,
...restaurantabout,
...footer,
//website Restaurent
...restaurantbanner,
...restaurantabout2,
...aboutapp,
...addbanner,
...startshopping,
...restaurantbenefits,
...Testimonial2,
...GetQuoteForm1,
// website supplier
  ...supplierbanner,
    ...aboutservice,
...AboutApp1,
...supplierpartner2,
...startshoppingSupplier,
...testimonialSupplier,
...supplierbenefits,
// About
...about,
...aboutServiceContent,
 ...workProcessContent,
 ...blogContent,
  ...contactContent,
};